import Logo from "./Logo";
import Image from "./Image";

function NavContent() {
  const profileSection =
    "https://res.cloudinary.com/nuirai/image/upload/v1647713007/passage/Untitled-1_wtxmik.png";
  return (
    <div className=" w-full h-full bg-slate flex items-center justify-between pr-3 pl-3">
      <div className=" h-8">
        <Logo />
      </div>
      <div>
        <Image src={profileSection}></Image>
      </div>
    </div>
  );
}

export default NavContent;
